


































































import Vue from "vue";
export default Vue.extend({
    name: "NavigationButton",
    components: {},
    props: {
        text: String,
        icon: String,
        action: Function,
        specificPath: String,
        enable: Boolean,
        hoverDisabledMessage: String,
        buttonId: String
    },
    data: () => {
        return {};
    },
    computed: {},
    methods: {}
});
